var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn",class:[
    ("btn-size_" + _vm.size),
    ("btn-type_" + _vm.type),
    ("btn-color_" + _vm.color),
    {
      'btn-fill': _vm.fill,
      'btn_icon-btn': !!_vm.icon,
      'btn-overlay': _vm.overlay,

      btn_disabled: _vm.disabled,
    } ],attrs:{"id":_vm.id,"disabled":_vm.disabled,"type":_vm.actionType}},_vm.$listeners),[(_vm.loading)?_c('Spinner',{attrs:{"size":"20"}}):_vm._e(),_c('div',{staticClass:"btn-container flex-centering",class:{ 'btn-loading': _vm.loading }},[_c(_vm.leftIconComponent,{tag:"component",staticClass:"btn-icon btn-icon_left"}),_c(_vm.onlyIcon,{tag:"component",staticClass:"btn-icon btn-icon_center"}),_vm._t("default"),_c(_vm.rightIconComponent,{tag:"component",staticClass:"btn-icon btn-icon_right"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }